const sliders = document.querySelectorAll('.product-swiper-main');

const initSlider = (item) => {
  if (item.parentElement.parentElement.parentElement.querySelector('.product-swiper-thumbs')) {
    let options = {
      loop: false,
      iOSEdgeSwipeDetection: true,
      iOSEdgeSwipeThreshold: 0,
      simulateTouch: true,
      preventInteractionOnTransition: true,
      slidesPerView: 'auto',
      height: 'auto',
      centeredSlides: false,
      spaceBetween: 10,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      slideToClickedSlide: true,
      breakpoints: {
        992: {
          spaceBetween: 20,
          slidesPerView: 5,
        },
      },
    };

    const thumbSwiper = new Swiper(
      item.parentElement.parentElement.parentElement.querySelector('.product-swiper-thumbs'),
      options
    );

    const updateMoreSlides = () => {
      const totalSlides = thumbSwiper.slides.length - 1;
      const visibleSlides = thumbSwiper.visibleSlidesIndexes;
      const lastVisibleSlideIndex = visibleSlides[visibleSlides.length - 1];
      const hiddenSlides = totalSlides - lastVisibleSlideIndex;

      const moreSlidesEl = thumbSwiper.el.querySelector('.more-slides');
      if (!moreSlidesEl) return;

      const lastVisibleSlide = thumbSwiper.slides[lastVisibleSlideIndex];
      lastVisibleSlide.appendChild(moreSlidesEl);

      if (hiddenSlides > 0) {
        moreSlidesEl.textContent = `+${hiddenSlides}`;
        moreSlidesEl.classList.add('flex');
        moreSlidesEl.classList.remove('hidden');

        moreSlidesEl.onclick = () => {
          thumbSwiper.slideTo(thumbSwiper.clickedIndex, 500);
        };
      } else {
        moreSlidesEl.classList.remove('flex');
        moreSlidesEl.classList.add('hidden');
        moreSlidesEl.onclick = null;
      }
    };

    thumbSwiper.on('init', updateMoreSlides);
    thumbSwiper.on('slideChange', updateMoreSlides);

    updateMoreSlides();

    options = {
      navigation: {
        nextEl: item.parentElement.parentElement.querySelector('.product-swiper-main-nav__next'),
        prevEl: item.parentElement.parentElement.querySelector('.product-swiper-main-nav__prev'),
      },
      loop: false,
      speed: 500,
      observer: true,
      observeParents: true,
      iOSEdgeSwipeDetection: true,
      iOSEdgeSwipeThreshold: 0,
      simulateTouch: true,
      preventInteractionOnTransition: true,
      slidesPerView: 1,
      height: 'auto',
      centeredSlides: false,
      spaceBetween: 10,
      slideToClickedSlide: true,
      thumbs: {
        swiper: thumbSwiper,
      },
    };

    const mainSwiper = new Swiper(item, options);

    const videoBtns = item.querySelectorAll('.btn-video');
    if (videoBtns.length > 0) {
      videoBtns.forEach((videoBtn) => {
        videoBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const videoId = videoBtn.dataset.videoId; // target slide id
          const targetSlide = item.querySelector(`.swiper-slide[data-swiper-id="${videoId}"]`);

          if (targetSlide) {
            const slides = Array.from(item.querySelectorAll('.swiper-slide'));
            const slideIndex = slides.indexOf(targetSlide);
            if (slideIndex >= 0) {
              mainSwiper.slideTo(slideIndex, 500); // scroll to the correct slide
            }
          }
        });
      });
    }
  }
};

sliders.forEach((item, i) => {
  initSlider(item);
});
